import { pgTable, text, timestamp, integer, bigint, index, foreignKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { manager } from './admin';
import { user } from './user';

export const chat = pgTable('Chat', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  managerId: integer().notNull(),
  userId: integer(),
  telegramChatId: bigint({ mode: 'number' }).notNull(),
  status: text().notNull(),
  // Chat metadata from Telegram
  title: text(),                                // Название чата (имя пользователя или группы)
  username: text(),                             // @username (если есть)
  avatarUrl: text(),                            // URL аватара
  summary: text(),                              // Последнее сообщение (для превью)
  lastMessageDate: timestamp({ precision: 3, mode: 'date' }), // Дата последнего сообщения
  chatType: text().default('user'),             // Тип чата: user, group, channel, bot
  // Read status tracking
  readInboxMaxId: bigint({ mode: 'number' }),   // Last message ID read by us
  readOutboxMaxId: bigint({ mode: 'number' }),  // Last message ID read by them
  unreadCount: integer().default(0),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('Chat_managerId_idx').using('btree', table.managerId.asc().nullsLast()),
  index('Chat_status_idx').using('btree', table.status.asc().nullsLast()),
  index('Chat_userId_idx').using('btree', table.userId.asc().nullsLast()),
  foreignKey({
    columns: [table.managerId],
    foreignColumns: [manager.id],
    name: 'Chat_managerId_fkey'
  }).onUpdate('cascade').onDelete('restrict'),
  foreignKey({
    columns: [table.userId],
    foreignColumns: [user.id],
    name: 'Chat_userId_fkey'
  }).onUpdate('cascade').onDelete('set null'),
]);

export const dailyReport = pgTable('DailyReport', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  managerId: integer().notNull(),
  content: text().notNull(),
  summary: text(),
  type: text().default('TEXT').notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('DailyReport_createdAt_idx').using('btree', table.createdAt.asc().nullsLast()),
  index('DailyReport_managerId_idx').using('btree', table.managerId.asc().nullsLast()),
  foreignKey({
    columns: [table.managerId],
    foreignColumns: [manager.id],
    name: 'DailyReport_managerId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);
